module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_2"
    }
  }, [_c('span', [_vm._v("Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("By Nicki Bennett")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Torn from his home and family by slavers, Varan escapes the brutality of the mines only to struggle for existence in the hellish desert of an alien world. When he stumbles across an injured, winged being, he can barely believe the beautiful stranger isn’t a hallucination conjured by his loneliness. Hiding from the slavers as they learn to communicate, Varan teaches Tvri’il how to survive, and Tvri’il teaches Varan how to love again. But can that love endure once the secrets of the slave planet—and of Tvri’il himself—are revealed?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355e0080","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0